import { LOCALES } from 'utils/languageUtils';

/** @type {Readonly<Record<LOCALES.ENGLISH | LOCALES.GREEK, Record<string, string>>>} */
const ROAMING_FORM_LABELS = Object.freeze({
  [LOCALES.ENGLISH]: {
    form: {
      title: 'Telekom Roaming',
      subtitle: 'Search for roaming packages',
      countryPlaceholder: 'Where are you traveling?',
      emptySearchMessage: 'No results found',
      emptyOptionsMessage: 'No countries found',
      submit: 'Search',
    },
    errors: {
      countryRequired: 'Please fill all required fields',
      typeRequired: 'Please fill all required fields',
    },
  },
  [LOCALES.GREEK]: {
    form: {
      title: 'Telekom Roaming',
      subtitle: 'Αναζήτηση πακέτων περιαγωγής',
      countryPlaceholder: 'Πού θα ταξιδέψεις;',
      emptySearchMessage: 'Δεν βρέθηκαν αποτελέσματα',
      emptyOptionsMessage: 'Δεν βρέθηκαν χώρες',
      submit: 'Αναζήτηση',
    },
    errors: {
      countryRequired: 'Παρακαλώ έλεγξε τα πεδία',
      typeRequired: 'Παρακαλώ έλεγξε τα πεδία',
    },
  },
});
export default ROAMING_FORM_LABELS;
